import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, Input } from '@material-ui/core';
import { genfunction } from '../../helpers';

import theme from '../../theme'

const useStyles = makeStyles(theme => ({
    leftrightbutton: {
        minWidth: "auto"
    },
    leftbutton: {
        width: "20px",
        borderTopLeftRadius: "0px",
        borderBottomLeftRadius: "0px"
    },
    rightbutton: {
        width: "20px",
        borderTopRightRadius: "0px",
        borderBottomRightRadius: "0px"
    },
    labelstyle: {
        flex: 1,
        padding: "0px 5px 0px 5px",
        verticalAlign: "middle",
        textAlign: "center"
    },
    box: {
        display: "flex",
        width: "80px"
    },
    input: {
        textAlign: "center"
    },
    boxVisble: {
        pointerEvents: "none",
        opacity: "0.4",
        backgroundColor: '#808080',
        color: '#000000'
    }
}));

const NumberSpinner = props => {
    const classes = useStyles();

    const buttonClickHandler = (operation) => {
        let newvalue = 0;
        if (operation == "Add") {
            newvalue = props.value + props.steps;
        }
        else if (operation == "Subtract") {
            newvalue = props.value - props.steps;
        }

        if (newvalue > props.maxValue)
            newvalue = props.maxValue;
        else if (newvalue < props.minValue)
            newvalue = props.minValue;

        if (newvalue != props.value)
            props.changeHandler(props.refrence, newvalue);
    }
    const handleFocus = (event) => event.target.select();

    const textChangeHandler = (event) => {
        if (event.target.value != "") {
            if (isNaN(event.target.value))
                event.target.value = 0;

            let newvalue = parseInt(event.target.value);
            if (newvalue > props.maxValue)
                newvalue = props.maxValue;
            else if (newvalue < props.minValue)
                newvalue = props.minValue;

            if (newvalue != props.value)
                props.changeHandler(props.refrence, newvalue);
        }
    }

    const disableButton = (type) => {

        if (type == "Max")
            return props.value >= props.maxValue;
        else if (type == "Min")
            return props.value <= props.minValue;
    }


    let boxVis = props.disabled ? classes.boxVisble : '';

    return (

        <div className={classes.box}>
            <Button size="small" className={classes.leftrightbutton + " " + classes.rightbutton
                + " " + boxVis} variant="contained" disabled={disableButton("Min")}
                color="primary" onClick={() => { buttonClickHandler("Subtract") }}>-</Button>
            <div className={classes.labelstyle}>
                <Input value={props.value}
                    inputProps={{
                        className: classes.input,
                        "data-hj-allow": ""
                    }}
                    onChange={textChangeHandler} onFocus={handleFocus}
                    disabled={genfunction.UniqueCouponApplied(props.refrence.eventCoupons, props.refrence.tourProductID, props.refrence.eventId)}
                ></Input>
            </div>
            <Button size="small" className={classes.leftrightbutton + " " + classes.leftbutton
                + " " + boxVis} variant="contained" disabled={disableButton("Max")}
                color="primary" onClick={() => { buttonClickHandler("Add") }}>+</Button>
        </div>
    );
};

NumberSpinner.propTypes = {
    value: PropTypes.number,
    steps: PropTypes.number,
    minValue: PropTypes.number,
    maxValue: PropTypes.number
};

export default NumberSpinner;
